import { t } from "@/i18n-js/instance";
import { Typography } from "@circle-react/components/shared/uikit/Typography";
import { Loader } from "../../shared/uikit/Loader";
import { UserGroupAvatar } from "./common/UserGroupAvatar";

interface QueueBannerProps {
  queuePosition: number | null;
}

const getQueueMessage = ({ queuePosition }: QueueBannerProps) => {
  if (queuePosition === 0) {
    return t("help_widget.queue_banner.next_in_line");
  }

  if (queuePosition === 1) {
    return t("help_widget.queue_banner.one_person_ahead");
  }

  return t("help_widget.queue_banner.people_ahead", { count: queuePosition });
};

export const QueueBanner = ({ queuePosition }: QueueBannerProps) => {
  const queueMessage = getQueueMessage({ queuePosition });

  return (
    <div className="bg-primary border-primary mx-4 flex items-center gap-2 rounded-2xl border px-4 py-2">
      <UserGroupAvatar count={Math.min(queuePosition || 0, 2)} size="6" />
      <div className="flex flex-1 flex-col">
        <Typography.LabelSm weight="semibold" color="text-darkest">
          {queueMessage}
        </Typography.LabelSm>

        <Typography.LabelXs color="text-tertiary">
          {t("help_widget.queue_banner.wait_message")}
        </Typography.LabelXs>
      </div>
      <div className="shrink-0">
        <Loader className="!p-0" />
      </div>
    </div>
  );
};
